import { schema } from "normalizr";

export const instructionsSets = new schema.Entity("instructionsSets");
export const instructionsSetsList = new schema.Array(instructionsSets);

export const instructionSteps = new schema.Entity("instructionSteps");
export const instructionStepsList = new schema.Array(instructionSteps);
